"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _colors = require("HubStyleTokens/colors");

var _getFeatureDescriptionKey = _interopRequireDefault(require("self-service-api/core/utilities/getFeatureDescriptionKey"));

var Hubs = _interopRequireWildcard(require("self-service-api/constants/Hubs"));

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  height: 40px;\n  width: 2%;\n  min-width: 30px;\n  & > p {\n    margin-left: 10px;\n    margin-bottom: 0;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  height: 40px;\n  & > p {\n    margin-bottom: 0;\n    font-weight: 500;\n  }\n  text-align: center;\n  width: 18.75%;\n  min-width: 175px;\n  :nth-child(2) {\n    width: 25%;\n    text-align: left;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  :nth-child(even) {\n    background-color: ", ";\n    :hover {\n      background-color: ", ";\n    }\n    & > th {\n      background-color: ", ";\n    }\n  }\n  :nth-child(odd) {\n    background-color: ", ";\n    :hover {\n      background-color: ", ";\n    }\n    & > th {\n      background-color: ", ";\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var TableRow = _styledComponents.default.tr.withConfig({
  displayName: "ProductCatalogTableRow__TableRow",
  componentId: "sc-2lshyl-0"
})(_templateObject(), _colors.OLAF, _colors.OLAF, _colors.OLAF, _colors.GYPSUM, _colors.GYPSUM, _colors.GYPSUM);

var LeftHeaderCell = _styledComponents.default.th.withConfig({
  displayName: "ProductCatalogTableRow__LeftHeaderCell",
  componentId: "sc-2lshyl-1"
})(_templateObject2());

var UserIconCell = _styledComponents.default.th.withConfig({
  displayName: "ProductCatalogTableRow__UserIconCell",
  componentId: "sc-2lshyl-2"
})(_templateObject3());

var UserIcon = function UserIcon(freeUserAccess) {
  return _react.default.createElement("p", null, _react.default.createElement(_UITooltip.default, {
    placement: "right",
    title: _react.default.createElement(_FormattedMessage.default, {
      message: "pricing-pages.freeUser." + freeUserAccess
    })
  }, _react.default.createElement(_UIIcon.default, {
    className: "m-right-1",
    name: "contacts"
  })));
};

var ProductCatalogTableRow = function ProductCatalogTableRow(_ref) {
  var featureId = _ref.featureId,
      children = _ref.children,
      hub = _ref.hub,
      freeUserAccess = _ref.freeUserAccess,
      _ref$showTooltip = _ref.showTooltip,
      showTooltip = _ref$showTooltip === void 0 ? true : _ref$showTooltip;
  return _react.default.createElement(TableRow, {
    key: featureId
  }, _react.default.createElement(UserIconCell, null, freeUserAccess && UserIcon(freeUserAccess)), _react.default.createElement(LeftHeaderCell, null, _react.default.createElement("p", {
    style: showTooltip ? {
      cursor: 'help'
    } : {}
  }, _react.default.createElement(_UITooltip.default, {
    placement: "right",
    disabled: !showTooltip,
    title: _react.default.createElement(_FormattedMessage.default, {
      message: (0, _getFeatureDescriptionKey.default)(featureId, hub)
    })
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "pricing-pages.features." + featureId + ".name"
  })))), children);
};

ProductCatalogTableRow.propTypes = {
  featureId: _propTypes.default.string.isRequired,
  children: _propTypes.default.node.isRequired,
  hub: _propTypes.default.oneOf(Object.keys(Hubs).map(function (hubKey) {
    return Hubs[hubKey];
  })).isRequired,
  freeUserAccess: _propTypes.default.string,
  showTooltip: _propTypes.default.bool
};
var _default = ProductCatalogTableRow;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/productCatalog/ProductCatalogTableRow.js
// module id = 694
// module chunks = 5 6